import Vue from "vue";
import moment = require("moment");
import common = require("../common");
import core = require("../core");
import context = require("../modules/context");
import config = require("../modules/config");
import utilities = require("../modules/utilities");
import SearchBoxResultsVue = require("../modules/vue/SearchBoxResultsVue");
import SearchBoxHeaderVue = require("../modules/vue/SearchBoxHeaderVue");
import HotEditableFormAction = require("../modules/vue/hotEditable/HotEditableFormAction");
import AjaxService = require("../services/AjaxService");
import AjaxRequest = require("../services/AjaxRequest");
import PageService = require("../services/PageService");
import FormService = require("../services/FormService");
import Pooler = require("./Pooler");
import InfiniteScroll = require("vue-infinite-scroll/vue-infinite-scroll.js");
import { error } from "jquery";

declare function require(name: string): any;

//var jsUtilities = require('../../js/jsUtilities');
//var jsClasses = require("../../js/jsClasses");

interface IPageSetup {
    size: number;
    number: number;
}

interface IPostedData {
    url: string;
    arguments: any;
}

//Controller pour le SearchBox
class SearchBox implements common.IPoolable {
    customData: common.IPostCustomData;
    onFetchingPreconfiguredFiltersCallback: (preconfiguredFilters: common.ISearchBoxPreconfiguredFilters[]) => void;
    defaultSearchFilters: common.ISearchFilter[];
    private readonly _defaultMaxItems = 500;
    private _$moduleRoot: JQuery = null;
    private _mover: core.Mover;
    private _loader: core.Loader;
    private _isInitialCall: boolean;
    private _focusedItemId?: string;
    private _isOnPoolingActive: boolean;
    private _isPoolingBypassed: boolean;
    private _searchApiUrl: string;
    private _searchParameters: common.ISearchParameters;
    private _searchBoxContext: common.ISearchBoxContext;
    private _searchBoxResultsVue: SearchBoxResultsVue = null;
    private _searchBoxHeaderVue: SearchBoxHeaderVue = null;
    private _itemsCountLimit: number;
    private _pooler: Pooler;
    private _lastSearchedTerms = "";
    /** =EnableFilters (config) */
    private _hasFilters: boolean;
    /** =EnableTerms (config) */
    private _hasTerms: boolean;
    private _confirmPopup: core.ConfirmationPopup = null;
    private _poolerPopup: core.ConfirmationPopup = null;
    private _messageNotification: core.MessageNotification = null;
    private _afterSearchAction: () => void;
    private _onPerformActionSuccessCallback: (focusedItemId: string) => void;
    private _maxModifiedResultDateUtc: string;
    private _filtersFormName?: string;
    private _ajaxService: AjaxService;
    private _pageService: PageService;
    private _formService: FormService;
    private _lastPostedData = null as IPostedData;
    private _lastSearchAjaxRequest = null as AjaxRequest;
    // private _actionToolTips = [
    //     //INFO : Mechanisme de tool tip dymanique permettant le support des texts variant en fonction de l'etat de l'action.
    //     //{
    //     //    actionType: common.ToolsBarActionType.SelectAll,
    //     //    enableToolTip: "Cocher tous les éléments visibles",
    //     //    disableToolTip: "Impossible de cocher tous les éléments visible."
    //     //},
    //     //{
    //     //    actionType: common.ToolsBarActionType.UnselectAll,
    //     //    enableToolTip: "Décocher tous les éléments",
    //     //    disableToolTip: "Au moins un élément doit être sélectionné pour être en mesure de désélectionner tous les éléments."
    //     //}
    // ] as common.IActionToolTipMapping[];

    private _defaultParamsFilterName = "defaultParams";

    constructor(s: common.ISearchBoxSettings, filtersFormName?: string, pooler?: Pooler) {
        this._isInitialCall = true;

        this._filtersFormName = filtersFormName || null;

        // Ensure settings ready
        this._searchParameters = s.searchParameters;

        // Manage default search filters
        this.defaultSearchFilters = s.defaultSeachFilters && s.defaultSeachFilters.length ? s.defaultSeachFilters : null;
        if (this.defaultSearchFilters) {
            this.defaultSearchFilters.push({
                fieldName: this._defaultParamsFilterName,
                values: ["true"]
            } as common.ISearchFilter);

            var currentDefaultParamsFilter = null;
            if (this._searchParameters && this._searchParameters.filters)
                for (let i = 0; i < this._searchParameters.filters.length; i++) {
                    const f = this._searchParameters.filters[i];
                    if (f.fieldName === this._defaultParamsFilterName) {
                        currentDefaultParamsFilter = f;
                        break;
                    }
                }

            if (!currentDefaultParamsFilter || !currentDefaultParamsFilter.values ||
                (currentDefaultParamsFilter.values.length && currentDefaultParamsFilter.values[0] === 'true')) {
                // Application des valeurs par default dans le cas ou ils seraient non-definies.
                utilities.appendSearchParametersFilters(this._searchParameters, this.defaultSearchFilters);
            }
        }

        this._searchBoxContext = s.searchBoxContext || {} as common.ISearchBoxContext;
        this._hasFilters = s.hasFilters || false;
        this._hasTerms = s.hasTerms || false;

        this.setupLoader();
        this.setupMover();

        this.customData = s.customData || {} as common.IPostCustomData;

        this._ajaxService = new AjaxService();
        this._pageService = new PageService();
        this._formService = new FormService(null);
        this._isOnPoolingActive = this._searchBoxContext.isOnPoolingActive;
        this._isPoolingBypassed = false;
        this._focusedItemId = s.focusedItemId || null;
        this._searchApiUrl = context.webServices.searchApiUrl;
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");
        this._poolerPopup = new core.ConfirmationPopup("#SearchBoxActionConfirmPopup.mod-popup");
        this._messageNotification = new core.MessageNotification(new core.MessageNotificationConfig("{id}_SearchBoxTopMessageNotification".replace("{id}", this._searchBoxContext.id)));
        this._$moduleRoot = $("#" + this._searchBoxContext.id);

        if (!this._searchBoxContext.maxItems)
            this._searchBoxContext.maxItems = this._defaultMaxItems;
        this._itemsCountLimit = this._searchBoxContext.maxItems;

        this.turnSearchIsRunningAtFalse();

        const initializedId = s.searchBoxContext.id ?? utilities.createGuid("N");
        const formName = "SearchBoxForm";
        this.setupResults(s, formName, "#{id} .msb-results-inner".replace("{id}", initializedId));
        this.setupHeader(s, formName, "#{id} .msb-header".replace('{id}', initializedId));
        this.setupSearching();

        if (pooler) {
            this._pooler = pooler;
            pooler.registerPoolable(this);
        }
    }

    private setupResults(s: common.ISearchBoxSettings, formName: string, elId: string) {
        // Banner actions
        const actions = [] as common.ISearchBoxAction[];
        for (let i = 0; i < (s.actions || []).length; i++) {
            const a = s.actions[i];
            if (a.selectionRule === common.ToolsBarSelectionRules.bannerAction)
                actions.push(a);
        }

        Vue.use(InfiniteScroll);
        Vue.prototype.initialData = {
            searchBox: this,
            el: elId,
            formName: formName,
            defaultNoResultText: s.defaultNoResultText,
            goToServerOnItemClick: s.goToServerOnItemClick === true,
            actions: actions
        } as common.ISearchBoxResultsInitialData;

        this._searchBoxResultsVue = new SearchBoxResultsVue()
            .setOnAction((type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean, selectedItems: common.ISelectedItem[]) => {
                this.onAction(type, selectionRule, confirmationTitleHtml, confirmationMessageHtml, isCtlClick, selectedItems);
            })
            .setOnInfiniteScrollLoadMoreCallback(() => {
                this.onInfiniteScrollLoadMore();
            })
            .setSorterCallback((name: string, order: string) => {
                this.onSorterChanged(name, order);
            })
            .setOnExportButtonCallback(() => {
                this.innerExport(true);
            });

        this._searchBoxResultsVue.shared.setActionCallback((a: HotEditableFormAction) => {
            this.onResultsAction(a);
        });
    }

    /** Doit etre execute APRES setupResults */
    private setupHeader(s: common.ISearchBoxSettings, formName: string, elId: string) {
        // Header actions
        const actions = [] as common.ISearchBoxAction[];
        for (let i = 0; i < (s.actions || []).length; i++) {
            const a = s.actions[i];
            if (a.selectionRule !== common.ToolsBarSelectionRules.bannerAction)
                actions.push(a);
        }

        Vue.prototype.initialData = {
            searchBox: this,
            el: elId,
            formName: formName,
            openFiltersOnInit: s.openFiltersOnInit === true,
            actions: actions
        } as common.ISearchBoxHeaderInitialData;

        this._searchBoxHeaderVue = new SearchBoxHeaderVue()
            // .setHeaderAtions(actions)
            .setOnAction((type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean) => {
                this.onAction(type, selectionRule, confirmationTitleHtml, confirmationMessageHtml, isCtlClick);
            })
            .setOnSelectAllActionClick(() => {
                this.updateAllResultsSelection(true);
            })
            .setOnUnelectAllActionClick(() => {
                this.updateAllResultsSelection(false);
            })
            .setOnFilterButtonClick(() => {
                this.toggleFilters();
            })
            .setFiltersUpdateCallback(hasActiveFilters => {
                this.onFiltersUpdate(hasActiveFilters);
            });

        this._searchBoxHeaderVue.shared.setActionCallback((a: HotEditableFormAction) => {
            if (a.getFieldName() === "TermsBox")
                this.onTermsAction(a);
            else
                this.onFiltersFormAction(a);
        });

        // this._searchBoxResultsVue
        //     .setBannerActions(bannerActions)
        //     .setOnAction((type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean, selectedItems: common.ISelectedItem[]) => {
        //         this.onAction(type, selectionRule, confirmationTitleHtml, confirmationMessageHtml, isCtlClick, selectedItems);
        //     });
    }

    private setupLoader() {
        const target = "#{id} .msb-results".replace("{id}", this.getId());
        this._loader = new core.Loader("#{id}_SearchBoxResultsLoading".replace("{id}", this.getId()), target, false);
    }

    private setupMover() {
        this._mover = new core.Mover("#{id}_SearchBoxMover".replace("{id}", this.getId()));
        const f = () => {
            const topOffset = utilities.topOffset();
            if (topOffset > 125)
                this._mover.show();
            else
                this._mover.hide();
        };
        $(window as any).on('resize', f).on('scroll', f);
        f();
    }

    destroy() {

        this.unregisterPoolable();

        this._isOnPoolingActive = false;
        this._isPoolingBypassed = true;

        if (this._searchBoxResultsVue) {
            this._searchBoxResultsVue.shared.destroyComponents();
            this._searchBoxResultsVue.$destroy();
            this._searchBoxResultsVue = null;
        }

        if (this._searchBoxHeaderVue) {
            this._searchBoxHeaderVue.shared.destroyComponents();
            this._searchBoxHeaderVue.$destroy();
            this._searchBoxHeaderVue = null;
        }
    }

    getId() {
        return this._searchBoxContext.id;
    }

    getModuleDimensions() {
        if (!this._$moduleRoot)
            throw "Le module jQuery est null.";
        return utilities.getDimensions(this._$moduleRoot);
    }

    onPooling(poolerFetchArguments: common.IPoolerFetchArguments, info: common.IPoolerInformations) {
        if (this._isPoolingBypassed || this.searchIsRunning())
            return false;

        const n = Math.ceil((context.pooler.searchBoxPoolingFrequencySec / 60) * (60 / info.frequencySec));
        const mustPool = this._isOnPoolingActive && !!info.iteration/* ne pas pooler au premier call */ && info.iteration % n === 0;

        if (mustPool) {
            const spCopy = utilities.copySearchParameters(this._searchParameters);
            const args = this.buildSearchBoxArguments(spCopy);
            args.isInitialCall = true//forcer a TRUE
            poolerFetchArguments.searchBoxFetchArgs.push({
                currentTotalItem: this.getTotalResults(),
                currentMaxModifiedResultDateUtc: this._maxModifiedResultDateUtc,
                searchBoxArguments: args
            } as common.ISearchBoxFetchArguments);
        }

        return mustPool;
    }

    onPoolingSuccess(responseData: common.IPoolingFetchResponseData) {
        if (this.searchIsRunning())
            return;

        const current = this.getCurrentSearchBoxPoolingFetchData(responseData.searchBoxData);

        if (!current)
            return;

        if (current.applyRefresh && utilities.isSameSearchParameters(current.searchParameters, this._searchParameters))
            if (current.confirmationHtmlMessage) {
                if (current.confirmationHtmlTitle)
                    this._poolerPopup.setHtmlTitle(current.confirmationHtmlTitle);

                this._poolerPopup
                    .setHtmlMessage(current.confirmationHtmlMessage)
                    .showWithAction(
                        // Oui
                        () => this.refresh(),
                        // Non
                        () => this.unregisterPoolable());
            }
            else {
                this.refresh();
            }

        this.onFetchingPreconfiguredFilters(current.preconfiguredFilters);
    }

    onPoolingError(errors: common.IError[]) {
        if (this.searchIsRunning())
            return;

        const m = context.components.getMessagesManager();
        (errors || []).forEach(x => m.displayErrorAsMessage(x, this.getId(), true, false));
    }

    private unregisterPoolable() {
        if (this._pooler)
            this._pooler.unregisterPoolable(this);
    }

    onFetchingPreconfiguredFilters(preconfiguredFilters: common.ISearchBoxPreconfiguredFilters[]) {
        if (this.onFetchingPreconfiguredFiltersCallback && preconfiguredFilters)
            this.onFetchingPreconfiguredFiltersCallback(preconfiguredFilters)
    }

    setOnFetchingPreconfiguredFiltersCallback(callback: (preconfiguredFilters: common.ISearchBoxPreconfiguredFilters[]) => void) {
        this.onFetchingPreconfiguredFiltersCallback = callback || null;
        return this;
    }

    refresh(focusedItemId?: string, onSuccess?: (isSuccess: boolean) => void) {

        this._focusedItemId = focusedItemId;

        const doSearch = () => {
            const spCopy = utilities.copySearchParameters(this._searchParameters);
            spCopy.pageNumber = 1;

            const args = this.buildSearchBoxArguments(spCopy);
            args.isInitialCall = true;//forcer a TRUE

            this.performSearch(args, false, true, onSuccess);
        }

        this.safeCallApi(doSearch);
    }

    setOnPerformActionSuccessCallback(callback: (focusedItemId: string) => void) {
        if (callback)
            this._onPerformActionSuccessCallback = callback;
        return this;
    }

    private getCurrentSearchBoxPoolingFetchData(searchBoxPoolingFetchData: common.ISearchBoxPoolingFetchResponseData[]) {
        for (let i = 0; i < (searchBoxPoolingFetchData || []).length; i++) {
            const x = searchBoxPoolingFetchData[i];
            if (x.contextName === this._searchBoxContext.name)
                return x;
        }
        return null;
    }

    private updateActions(updatedActions?: common.IToolsBarUpdatedAction[]) {
        if (!updatedActions)
            return;

        const selectedItems = this._searchBoxResultsVue.collectSelectedItems();

        this._searchBoxHeaderVue.updateHeaderActions(updatedActions, selectedItems);
        this._searchBoxResultsVue.updateBannerActions(updatedActions, selectedItems);
    }

    private updateAllResultsSelection(isSelected: boolean) {
        this._searchBoxResultsVue.selectAllCheckboxes(isSelected);
    }

    private innerExport(bypassValidation?: boolean) {
        bypassValidation = bypassValidation === true;
        if (bypassValidation || this._searchBoxResultsVue.showExportButton)
            this.performAction(null, null, null, null, null, false, true);
    }

    export() {
        this.innerExport();
    }

    private onAction(type: common.ToolsBarActionTypes, selectionRule: common.ToolsBarSelectionRules, confirmationTitleHtml: string, confirmationMessageHtml: string, isCtlClick: boolean, selectedItems?: common.ISelectedItem[]) {

        selectedItems = selectedItems || this._searchBoxResultsVue.collectSelectedItems();

        var messageMappings: {};

        if (confirmationMessageHtml) {

            const buildDefaultMappings = (msg: string) => {
                const o = {};
                o[common.ToolsBarSelectionRules.nothingOrMultiSelect] = msg + '';
                return o;
            };

            messageMappings = utilities.asObject(confirmationMessageHtml) || buildDefaultMappings(confirmationMessageHtml);
        }
        else {
            messageMappings = null;
        }

        const getMessageMapping = () => {
            for (let k in messageMappings || {})
                if (messageMappings.hasOwnProperty(k) && this.validateSelectionRule(k, selectedItems))
                    return messageMappings[k];
            return null;
        };

        this.performAction(type, selectionRule, selectedItems, confirmationTitleHtml, getMessageMapping(), isCtlClick);
    }

    private performAction(actionType: common.ToolsBarActionTypes,
        selectionRule: string,
        selectedItemIds: common.ISelectedItem[],
        confirmationHtmlTitle?: string,
        confirmationHtmlMessage?: string,
        isCtlClick?: boolean,
        isExportAction?: boolean) {

        isExportAction = isExportAction === true;

        const itemIdsCopy = [];
        const itemIdsTemp = selectedItemIds && selectedItemIds.length ? selectedItemIds : this._searchBoxResultsVue.collectSelectedItems() ?? [];
        for (let i = 0; i < itemIdsTemp.length; i++)
            itemIdsCopy.push(itemIdsTemp[i]);

        const f = () => {
            this.turnSearchIsRunningAtTrue();
            this.resetMessages();
            this.lockScreen();

            var toolsBarActionArguments = {} as common.IToolsBarActionArguments;
            var searchBoxArguments = {} as common.ISearchBoxArguments;

            const spCopy = utilities.copySearchParameters(this._searchParameters);
            if (isExportAction) {
                searchBoxArguments = this.buildSearchBoxArguments(spCopy, toolsBarActionArguments);
                searchBoxArguments.performExport = true;
            }
            else {
                toolsBarActionArguments = {
                    type: actionType ? actionType.toString() : '',
                    selectedItems: selectedItemIds,
                    isCtlClick: isCtlClick === true
                } as common.IToolsBarActionArguments;
                searchBoxArguments = this.buildSearchBoxArguments(spCopy, toolsBarActionArguments);
            }

            const formName = this._searchBoxHeaderVue.formManager.getFormName();

            this._isPoolingBypassed = true;
            this.postData(
                this._searchApiUrl,
                searchBoxArguments,
                formName ? utilities.extractFormData("form[name='" + formName + "']") : null,
                selectionRule,
                //on validation error
                (currentType: string, currentSelectionRule: string) => {
                    this.unlockScreen();
                    const errorMessage = "Une erreur c'est produite pour l'action '{t}' (validation : '{r}')."
                        .replace("{t}", currentType || "NA")
                        .replace("{r}", currentSelectionRule || "NA");
                    this.displayErrorFromText(errorMessage);
                    //this._topMessageNotification.displayErrorMessage(errorMessage);
                },
                //on success
                (data: common.ISearchBoxResponseData) => {
                    this.unlockScreen();

                    const repost = () => this.performAction(actionType, selectionRule, itemIdsCopy, confirmationHtmlTitle, confirmationHtmlMessage, isCtlClick, isExportAction);
                    if (FormService.confirm(
                        formName,
                        this._confirmPopup,
                        data.confirmationMessages,
                        () => {
                            // Accepted
                            this.turnSearchIsRunningAtFalse();
                            repost();
                        },
                        returnToApiOnDenied => {
                            this.turnSearchIsRunningAtFalse();
                            // Denied
                            if (returnToApiOnDenied)
                                repost();
                        }))
                        return;

                    if (!data)
                        return;

                    //On update l'url même avant une redirection pour que le back fonctionne.
                    if (data.updatedUrl)
                        this.updateBrowserUrl(data.updatedUrl);

                    this._searchBoxResultsVue.noResultText = data.noResultText || null;

                    if (data.exportUrl) {
                        utilities.redirect(data.exportUrl);
                    }
                    else if (data.actionData.redirectUrl) {
                        if (data.actionData.redirectPostData) {
                            const id = ''; //this.getId() + "_";
                            const json = utilities.asString(data.actionData.redirectPostData);
                            const formTarget = "form#{id}SearchBoxForm".replace("{id}", id);
                            const inputTarget = "input#{id}SearchBoxForm".replace("{id}", id);
                            const $form = $(formTarget);
                            const $input = $form.find(inputTarget);
                            $input.val(json);
                            $form.attr("action", data.actionData.redirectUrl).trigger('submit');
                        } else {
                            utilities.redirect(data.actionData.redirectUrl, data.actionData.redirectUrlInNewTab === true);
                            this.turnSearchIsRunningAtFalse();
                            return;
                        }
                    }

                    if (data.searchParameters && !data.cancelDataUpdate)
                        utilities.updateSearchParameters(this._searchParameters, data.searchParameters);

                    const updateActionsButtons = () => {
                        this.updateActions((data.actionData || {} as common.IToolsBarActionResponseData).updatedActions);

                        if (data.actionData.successMessage)
                            //this._topMessageNotification.displaySuccessMessage(data.actionData.successMessage);
                            this.displayMessage(null, data.actionData.successMessage, true, common.MessageTypes.info);
                    };

                    //Si une recherche a été effectuée côté serveur on réassigne les résultats.
                    if (data.actionData.performSearch && !data.cancelDataUpdate) {
                        this.setTotalResults(data.totalItems);

                        const canGoToFirstItemOnReset = !data.focusedItemId;

                        this.setResults(data, canGoToFirstItemOnReset, null, () => {
                            this.updateItemsCountLimit(data.totalItems);

                            if (this._hasFilters)
                                this._searchBoxHeaderVue.updateFiltersFromSearchParameters(this._searchParameters);

                            if (this._hasTerms)
                                this._searchBoxHeaderVue.updateTermsFromSearchParameters(this._searchParameters);

                            updateActionsButtons();
                            this.turnSearchIsRunningAtFalse();

                            this.goToItem(data.focusedItemId);
                            this.setShowExportButton(data);

                        });
                    } else if (!data.cancelDataUpdate) {
                        if (this._hasFilters)
                            this._searchBoxHeaderVue.updateFiltersFromSearchParameters(this._searchParameters);

                        if (this._hasTerms)
                            this._searchBoxHeaderVue.updateTermsFromSearchParameters(this._searchParameters);

                        updateActionsButtons();
                        this.turnSearchIsRunningAtFalse();

                        this.goToItem(data.focusedItemId);
                    }
                    else {
                        this.turnSearchIsRunningAtFalse();
                    }

                    if (this._onPerformActionSuccessCallback)
                        this._onPerformActionSuccessCallback(data.focusedItemId || null);

                    this._isPoolingBypassed = false;
                },
                //on error
                (errors) => {
                    this.unlockScreen();
                    this.displayErrors(errors);
                    //this._topMessageNotification.displayErrors(errors);

                    this.turnSearchIsRunningAtFalse();
                    this._isPoolingBypassed = false;
                }
            );
        };

        if (confirmationHtmlMessage) {
            if (confirmationHtmlTitle)
                this._poolerPopup.setHtmlTitle(confirmationHtmlTitle);

            this._poolerPopup
                .setHtmlMessage(confirmationHtmlMessage)
                .showWithAction(() => this.safeCallApi(f));
        }
        else {
            this.safeCallApi(f);
        }
    }

    /** resetAndKeepScrolingBar: permet de remplacer les résultats sans ramener le scrol bar en haut. */
    private performSearch(searchBoxArguments: common.ISearchBoxArguments, setTermsAfterSearch?: boolean, resetAndKeepScrolingBar?: boolean, callback?: (isSuccess: boolean) => void) {
        if (this.searchIsRunning())
            return;

        setTermsAfterSearch = setTermsAfterSearch !== false;

        this.turnSearchIsRunningAtTrue();
        this.resetMessages();
        //this.lockScreen();

        if (!searchBoxArguments.customData && this.customData) {
            // Transferer seulement les proprietes du CustomData qui n'existent pas dans les SearchBoxArguments 
            searchBoxArguments.customData = searchBoxArguments.customData || {} as common.IPostCustomData;

            for (var k in this.customData)
                if (this.customData.hasOwnProperty(k))
                    if (!searchBoxArguments.customData.hasOwnProperty(k))
                        searchBoxArguments.customData[k] = this.customData[k];
        }

        this._lastSearchAjaxRequest = this.postData(
            this._searchApiUrl,
            searchBoxArguments,
            null,
            null,
            null,
            //on success
            data => {
                //this.unlockScreen();

                if (data.actionData != null && data.actionData.redirectUrl !== null && data.actionData.redirectUrl !== undefined && data.actionData.redirectUrl !== "")
                    utilities.redirect(data.actionData.redirectUrl, false);

                this.setShowExportButton(data);

                utilities.updateSearchParameters(this._searchParameters, data.searchParameters);

                if (data.updatedUrl)
                    this.updateBrowserUrl(data.updatedUrl);

                this._searchBoxResultsVue.noResultText = data.noResultText || null;

                this.setTotalResults(data.totalItems);

                var canGoToFirstItemOnReset = true;
                if (data.focusedItemId || resetAndKeepScrolingBar)
                    canGoToFirstItemOnReset = false;

                this.setResults(
                    data,
                    canGoToFirstItemOnReset,
                    resetAndKeepScrolingBar,
                    () => {
                        this.updateItemsCountLimit(data.totalItems);

                        if (this._hasFilters)
                            this._searchBoxHeaderVue.updateFiltersFromSearchParameters(this._searchParameters);

                        if (this._hasTerms && setTermsAfterSearch)
                            this._searchBoxHeaderVue.updateTermsFromSearchParameters(this._searchParameters);

                        this.updateActions((data.actionData || {} as common.IToolsBarActionResponseData).updatedActions);

                        if (callback) callback(true);

                        // Si initialement demande plus que la page 1, on focus sur le premier item de la derniere page.
                        if (this._isInitialCall === true &&
                            data.searchParameters.pageNumber > 1 &&
                            !data.focusedItemId) {
                            const maxIndex = this.getVisibleItemsCount() - 1;
                            const focusedIndex = (data.searchParameters.pageNumber - 1) * data.searchParameters.pageSize + 1;

                            if (focusedIndex && focusedIndex <= maxIndex)
                                this.goToItem(this._searchBoxResultsVue.items[focusedIndex].id, true);
                        }

                        this.turnInitialCallAtFalse();

                        this.goToItem(data.focusedItemId, true);
                    }
                );

                this.turnSearchIsRunningAtFalse();
            },
            //on error
            (errors) => {
                //this.unlockScreen();
                this.displayErrors(errors);
                //this._topMessageNotification.displayErrors(errors);
                if (callback)
                    callback(false);
                this.turnSearchIsRunningAtFalse();
            }
        );
    }

    private setShowExportButton(data: common.ISearchBoxResponseData) {
        if (!data) return;

        if (data.displayExportButton === true || data.displayExportButton === false)
            this._searchBoxResultsVue.showExportButton = data.displayExportButton;
    }

    private onFiltersUpdate(hasActiveFilters: boolean) {
        hasActiveFilters = hasActiveFilters === true;
        if (this._hasTerms)
            this._searchBoxHeaderVue.updateFitlersButtonStatus(hasActiveFilters);
    }

    openFilters() {
        if (this._hasFilters)
            this._searchBoxHeaderVue.toggleFilters(common.PopupStates.opened);
        return this;
    }

    closeFilters() {
        if (this._hasFilters)
            this._searchBoxHeaderVue.toggleFilters(common.PopupStates.closed);
        return this;
    }

    toggleFilters(forcedState?: common.PopupStates) {
        if (this._hasFilters)
            this._searchBoxHeaderVue.toggleFilters(forcedState);
        return this;
    }

    private setupSearching() {
        if (this._hasTerms) {
            this._searchBoxHeaderVue.updateTermsFromSearchParameters(this._searchParameters);
            this._lastSearchedTerms = this._searchParameters.originalTerms;
        }

        this.setTotalResults(this._itemsCountLimit); //prevent NoResult banner to be displayed on initial rendering.
        this.setSorters();

        //Définir la dernière valeur de la recherche afin de permettre la recherche lorsqu'on supprime la valeur initiale (Ne pas enlever).
        this.performSearch(
            this.emptySearchArgs(this._searchBoxContext),
            true,
            false);
    }

    private onFiltersFormAction(action: HotEditableFormAction) {

        if (action.isButtonClick() && action.getButtonType() === common.HotEditableButtonTypes.close) {
            this.closeFilters()
            return;
        }

        var isReinit = false;
        if (this._hasFilters) {
            if (action.getFieldOrButtonName() === "ApplyButtons_Clear")
                // CLEAR BUTTON CLICK
                this._searchBoxHeaderVue.shared.clearAllVisibleFields();
            else if (action.getFieldOrButtonName() === "ApplyButtons_Reinit")
                // REINIT BUTTON CLICK
                if (this.defaultSearchFilters)
                    isReinit = true;
        }

        const f = () => {

            if (!this._hasFilters || !action.isButtonClick())
                return;

            if (isReinit) {
                utilities.updateSearchParametersFilters(this._searchParameters, { filters: this.defaultSearchFilters } as common.ISearchParameters);
                this._searchBoxHeaderVue.updateFiltersFromSearchParameters(this._searchParameters);
            }
            else {
                this._searchBoxHeaderVue.updateSearchParametersFromFilters(this._searchParameters);
                if (this.defaultSearchFilters)
                    this.appendDefaultParamsFilter(this._searchParameters);
            }

            const spCopy = utilities.copySearchParameters(this._searchParameters);
            spCopy.pageNumber = 1;

            this.lockScreen();
            this.performSearch(this.buildSearchBoxArguments(spCopy),
                true,
                false,
                isSuccess => {
                    if (this._hasFilters && this._searchBoxHeaderVue.isAutoCloseFiltersOnButtoClick())
                        this.closeFilters();
                    this.unlockScreen();
                });
        }

        this.safeCallApi(f);
    }

    private appendDefaultParamsFilter(sp: common.ISearchParameters) {
        sp = sp || {} as common.ISearchParameters;
        sp.filters = sp.filters || [];

        var defaultParamsFilter = null as common.ISearchFilter;
        for (let i = 0; i < sp.filters.length; i++) {
            const f = sp.filters[i];
            if (f.fieldName === this._defaultParamsFilterName) {
                defaultParamsFilter = f;
                break;
            }
        }

        if (defaultParamsFilter)
            defaultParamsFilter.values = ['false'];
        else
            sp.filters.push({
                fieldName: this._defaultParamsFilterName,
                values: ['false']
            } as common.ISearchFilter);
    }

    private onTermsAction(action: HotEditableFormAction) {
        if (!this._hasTerms)
            return;

        const originalTerms = this._searchBoxHeaderVue.getOriginalTerms();

        const doSearch = () => {
            this._searchBoxHeaderVue.updateSearchParametersFromTerms(originalTerms, this._searchParameters);

            const t = (this._searchParameters.originalTerms || '').trim();
            if (this._lastSearchedTerms === t)
                return;

            this._lastSearchedTerms = t;

            const spCopy = utilities.copySearchParameters(this._searchParameters);
            spCopy.pageNumber = 1;
            spCopy.originalTerms = t ? t : null;

            this.performSearch(this.buildSearchBoxArguments(spCopy), false, false);
        };

        this.safeCallApi(doSearch);
    }

    /** ATTENTION!! L'argument "futureSearchParameters" doit etre une copie */
    private buildSearchBoxArguments(futureSearchParameters: common.ISearchParameters, toolsBarActionArguments?: common.IToolsBarActionArguments) {
        return {
            currentSearchContext: this._searchBoxContext.name,
            searchParameters: futureSearchParameters,
            isInitialCall: this._isInitialCall,
            currentUrl: this.getCurrentUrl(),
            toolsBarActionArguments: toolsBarActionArguments || null,
            focusedItemId: this._focusedItemId || null,
            customData: this.customData || null,
        } as common.ISearchBoxArguments;
    }

    private onResultsAction(action: HotEditableFormAction) {

        if (action.isFieldChanged() && action.getFieldType() === common.HotEditableFieldTypes.checkbox) {
            const item = this._searchBoxResultsVue.getItemByCheckboxId(action.getId());

            item.searchBoxSelectField.isChecked = action.getFieldTextualValue() === "true";
        }

        if (!action.isFieldChanged)
            return;

        if (action.getFieldType() === common.HotEditableFieldTypes.checkbox &&
            action.getId().startsWith("SearchBoxSelectField_"))
            this.onSelectItem(action.getId());
    }

    private onSorterChanged(name: string, order: string) {

        const doSearch = () => {
            this._searchBoxResultsVue.updateSearchParametersFromSorter(this._searchParameters);

            const spCopy = utilities.copySearchParameters(this._searchParameters);
            spCopy.pageNumber = 1;

            this.performSearch(this.buildSearchBoxArguments(spCopy), true, false);
        };

        this.safeCallApi(doSearch);
    }

    private onInfiniteScrollLoadMore() {
        if (this._isInitialCall || this.searchIsRunning())
            return;

        const f = () => {
            //Si tout n'a pas été loadé.
            const currentLoadedItems = this.getVisibleItemsCount();

            if (currentLoadedItems >= this._itemsCountLimit)
                return;

            const spCopy = utilities.copySearchParameters(this._searchParameters);
            spCopy.pageNumber = spCopy.pageNumber + 1;// increment

            this.performSearch(this.buildSearchBoxArguments(spCopy), false, false, isSuccess => {
                if (this._hasFilters)
                    this._searchBoxHeaderVue.updateFiltersFromSearchParameters(this._searchParameters);
            });
        };

        this.safeCallApi(f);
    }

    private safeCallApi(action: () => void) {
        if (this.searchIsRunning()) {
            this._afterSearchAction = action;
            return;
        }

        this._searchBoxResultsVue.$nextTick(() => {
            action();
        });
    }

    private getVisibleItemsCount() {
        return this.getVisibleItems().length;
    }

    private setTotalResults(value?: number) {
        this._searchBoxResultsVue.totalResults = value || 0;
    }

    private getTotalResults(): number {
        return this._searchBoxResultsVue.totalResults || 0;
    }

    private setSorters() {
        this._searchBoxResultsVue.updateSorterFromSearchParameters(this._searchParameters);
    }

    private searchIsRunning() {
        return this._searchBoxResultsVue.searchIsRunning === true;
    }

    private turnSearchIsRunningAtTrue() {
        this._searchBoxResultsVue.searchIsRunning = true;
    }

    private turnSearchIsRunningAtFalse() {

        if (!this._searchBoxResultsVue)
            return;

        this._searchBoxResultsVue.searchIsRunning = false;

        if (this._afterSearchAction) {
            this._afterSearchAction();
            this._afterSearchAction = null;
        }
    }

    private onSelectItem(checkedCheckboxId: string) {
        const result = this._searchBoxResultsVue.getItemByCheckboxId(checkedCheckboxId);

        //this.updateItemsCounter();
        this._searchBoxResultsVue.updateSelectedProperty(result);
    }

    private displayErrorFromText(text: string, code?: number) {
        code = code || config.errors.codes.unknown;
        const e = new core.Error(text, code);

        this.displayError(e);
    }

    private displayError(error: common.IError) {
        this.displayErrors([error]);
    }

    private displayErrors(errors: common.IError[]) {
        (errors || [] as common.IError[]).forEach(x => {
            if (!this._searchBoxResultsVue.formManager.displayFieldError(this._filtersFormName, x, false))
                this.getMessageManager().displayErrorAsMessage(x, this._filtersFormName, true, true);
        });
    }

    private displayMessage(title?: string, text?: string, autoClose?: boolean, messageType?: common.MessageTypes) {
        text = text || '';
        const m = {
            autoClose: autoClose || null,
            title: title || null,
            contentHtml: text || null,
            messageType: messageType || null
        } as common.IMessage;
        this.getMessageManager().displayMessage(m, true);
    }

    private getMessageManager() {
        return context.components.getMessagesManager();
    }

    private scrollGrid(top: number, durationMs?: number, $container?: JQuery) {
        const defaultDurationMs = 375;

        durationMs = durationMs || durationMs === 0 ? durationMs : defaultDurationMs;
        $container = $container || this.getResultsContainer();

        $container.animate({
            scrollTop: top
        }, durationMs);
    }

    scrollGridTop(durationMs?: number) {
        this.scrollGrid(0, durationMs);
    }

    private getResultsContainer() {
        return $(".msb-results-container");
    }

    //Permet de positionner le navigateur vis-à-vis le checkbox d'un item.
    private goToItem(id: string, applyDelayOnNextTick?: boolean) {
        if (!id)
            return;

        applyDelayOnNextTick = applyDelayOnNextTick !== false;//Default is TRUE

        const f = () => {
            const $e = $(".msb-result[data-id='{id}']".replace("{id}", id));
            if (!$e.length)
                return;
            const $c = this.getResultsContainer();
            const eo = $e.offset();
            const co = $c.offset();

            this.scrollGrid(eo.top - co.top, 0, $c);
        };

        if (applyDelayOnNextTick)
            this._searchBoxResultsVue.$nextTick(() => { f(); });
        else
            f();
    }

    private turnInitialCallAtFalse() {
        if (this._isInitialCall) {
            this._isInitialCall = false;
            this._searchBoxResultsVue.isInitialized = true;
        }
    }

    private setResults(
        data: common.ISearchBoxResponseData,
        gotoFirstItemOnReset: boolean,
        resetAndKeepScrolingBar?: boolean,
        callback?: (results: common.ISearchBoxResult[]) => void) {

        const results = data.searchResults || [];

        const pageSetup = this.getCurrentPageSetup();
        const resetResults = resetAndKeepScrolingBar === true || !this._searchParameters.pageNumber || this._searchParameters.pageNumber === 1;

        if (resetResults) {
            this._maxModifiedResultDateUtc = data.maxModifiedResultDateUtc || null;
        }
        else {
            const currentDate = this._maxModifiedResultDateUtc ? moment(this._maxModifiedResultDateUtc, context.formats.dateTimeMomentWithMs) : null;
            const newDate = data.maxModifiedResultDateUtc ? moment(data.maxModifiedResultDateUtc, context.formats.dateTimeMomentWithMs) : null;

            if (newDate)
                if (currentDate) {
                    if (newDate > currentDate)
                        this._maxModifiedResultDateUtc = data.maxModifiedResultDateUtc;
                } else {
                    this._maxModifiedResultDateUtc = data.maxModifiedResultDateUtc;
                }
        }

        this.updateGroupedVariantCssClass(results);

        if (resetResults) {

            if (resetAndKeepScrolingBar !== true)
                while (this._searchBoxResultsVue.items.length > 30)
                    this._searchBoxResultsVue.items.pop();

            for (let i = 0; i < this._searchBoxResultsVue.items.length; i++)
                this._searchBoxResultsVue.items[i].id = this.getNewGuid();
        }

        if (resetResults && !results.length)
            for (let i = 0; i < this._searchBoxResultsVue.items.length; i++) {
                const x = this._searchBoxResultsVue.items[i];
                if (x.isVisible)
                    x.isVisible = false;
            }

        if (results) {

            var firstInvisibleIndex = resetResults && this._searchBoxResultsVue.items.length ? 0 : null;

            if (!resetResults)
                for (let i = 0; i < this._searchBoxResultsVue.items.length; i++) {
                    const x = this._searchBoxResultsVue.items[i];
                    if (x.isVisible !== true) {
                        firstInvisibleIndex = i;
                        break;
                    }
                }

            for (let i = 0; i < results.length; i++) {
                const x = results[i];

                if (!x.isVisible)
                    x.isVisible = true;

                if (firstInvisibleIndex === null) {
                    x.uid = this.getNewGuid();
                    this._searchBoxResultsVue.items.push(x);
                } else {
                    this.autoMap(x, this._searchBoxResultsVue.items[firstInvisibleIndex]);
                    if (++firstInvisibleIndex > this._searchBoxResultsVue.items.length - 1)
                        firstInvisibleIndex = null;
                }
            }

            const lastIndex = pageSetup.size * (pageSetup.number - 1) + results.length - 1;

            if (lastIndex < this._searchBoxResultsVue.items.length - 1)
                for (let n = lastIndex + 1; n < this._searchBoxResultsVue.items.length; n++) {
                    const x = this._searchBoxResultsVue.items[n];
                    if (x.isVisible)
                        x.isVisible = false;
                }
        }

        if (gotoFirstItemOnReset && resetResults && this._searchBoxResultsVue.items.length)
            this.goToItem(this._searchBoxResultsVue.items[0].id, true);

        this._searchBoxResultsVue.updateSelectedProperties(this.getVisibleItems());

        if (callback) callback(results);
    }

    private getVisibleItems() {
        const r = [];
        for (let i = 0; i < (this._searchBoxResultsVue.items || []).length; i++) {
            const x = this._searchBoxResultsVue.items[i];
            if (x.isVisible === true)
                r.push(x);
            else
                break;
        }

        return r;
    }

    private setDefaultValues(result: common.ISearchBoxResult, propertyKey: string) {

        if (propertyKey === "uid")
            return;

        var value: string | boolean | common.ISearchBoxSelectField;

        if (propertyKey === "id")
            value = this.getNewGuid();
        else if (propertyKey === "model" || propertyKey === "clickUrl" || propertyKey === "groupPosition")
            value = null;
        else if (propertyKey === "selected" || propertyKey === "isVisible")
            value = false;
        else if (propertyKey === "type")
            value = "";
        else if (propertyKey === "searchBoxSelectField")
            value = {
                groupName: "",
                id: "SearchBoxSelectField_" + this.getNewGuid(),
                isChecked: false
            } as common.ISearchBoxSelectField;
        else
            value = null;

        (result[propertyKey] as any) = value;
    }

    private updateGroupedVariantCssClass(results: common.ISearchBoxResult[]) {
        if (!results || !results.length)
            return this;
        const groupPositions = {
            first: "first",
            middle: "middle",
            last: "last",
            alone: "alone",
            default: ""
        };
        const groups = [] as any[];
        const addToGroups = (res: common.ISearchBoxResult, ind: number) => {
            const groupName = res.searchBoxSelectField.groupName;
            for (let n = 0; n < groups.length; n++) {
                const g = groups[n];
                if (g.name === groupName) {
                    g.results.push(ind);
                    return;
                }
            }
            groups.push({ name: groupName, results: [ind] });
        };

        const updateResultPosition = (ind: number, pos: string) => {
            results[ind].groupPosition = pos;
        };

        for (let i = 0; i < results.length; i++) {
            const result = results[i];
            if (result.searchBoxSelectField && result.searchBoxSelectField.groupName)
                addToGroups(result, i);
            else
                result.groupPosition = groupPositions.default;
        }

        //Assigner la valeur a la fin seulement afin de ne pas declancher les watch angular.
        for (let i = 0; i < groups.length; i++) {
            const g = groups[i];
            if (g.results.length === 1)
                updateResultPosition(g.results[0], groupPositions.alone);
            else
                for (let j = 0; j < g.results.length; j++) {
                    const index = g.results[j];
                    var position: string;
                    if (j === 0)
                        position = groupPositions.first;
                    else if (j < g.results.length - 1)
                        position = groupPositions.middle;
                    else
                        position = groupPositions.last;
                    updateResultPosition(index, position);
                }
        }

        return this;
    }

    private emptySearchArgs(searchBoxContext: common.ISearchBoxContext) {
        const spCopy = utilities.copySearchParameters(this._searchParameters);
        const empty = this.buildSearchBoxArguments(spCopy);

        if (searchBoxContext.focusedItemId)
            empty.focusedItemId = searchBoxContext.focusedItemId;

        return empty;
    }

    private updateItemsCountLimit(totalResults: number) {
        const limit = this._searchBoxContext.maxItems;
        const loadedItemsCount = this.getVisibleItemsCount();

        //this.updateItemsCounter(loadedItemsCount);

        if (loadedItemsCount >= limit && totalResults > limit) {
            const m = "Vous avez atteint la limite du nombre d'items affichables ({max}). Veuillez raffiner votre recherche pour réduire le nombre d'items affichés.".replace('{max}', loadedItemsCount.toString());
            this._messageNotification.displayWarningMessage(m, false);
        }

        this._itemsCountLimit = Math.min(limit, totalResults);
    }

    private resetMessages() {
        this._messageNotification.reset();
        this.getMessageManager().closeAll();
    }

    private lockScreen() {
        const p = context.components.getPage();
        if (p)
            p.lockScreen(false);
    }
    private unlockScreen() {
        const p = context.components.getPage();
        if (p)
            p.unlockScreen();
    }

    private getCurrentPageSetup() {
        const defaultPageSize = 30;
        const defaultPageNumber = 1;
        return {
            size: this._searchParameters.pageSize || defaultPageSize,
            number: this._searchParameters.pageNumber || defaultPageNumber
        } as IPageSetup;
    }

    private getCurrentUrl() {
        return utilities.currentUrl();
    }

    private updateBrowserUrl(url: string) {
        this.isValidUrl(url, (errorMessage) => {
            throw errorMessage;
        });

        url = url.trim();

        if (url.toLowerCase() === this.getCurrentUrl().toLowerCase())
            return;

        utilities.updateBrowserUrl(url);
    }

    private isValidUrl(url: string, onInvalidUrl?: (errorMessage: string) => void) {
        if (!url) {
            if (onInvalidUrl)
                onInvalidUrl("L'URL est vide ou NULL.");
            return false;
        }
        const invalidStartWithValues = ["http://", "https://"];
        for (let i = 0; i < invalidStartWithValues.length; i++) {
            const invalidStartWithValue = invalidStartWithValues[i];
            if (url.substring(0, invalidStartWithValue.length) !== invalidStartWithValue)
                continue;
            if (onInvalidUrl)
                onInvalidUrl("L'URL ne doit pas commencer par '" + invalidStartWithValue + "'.");
            return false;
        }
        if (url.substring(0, 1) !== "/") {
            if (onInvalidUrl)
                onInvalidUrl("L'URL doit commencer par '/' (slash).");
            return false;
        }
        return true;
    }

    private getNewGuid() {
        return utilities.createGuid();
    }

    // Effectuer une recherche et/ou faire une action du ToolBox
    private postData(
        searchBoxWebServiceUrl: string,
        searchBoxArguments: common.ISearchBoxArguments,
        confirmationsFormData?: FormData,
        selectionRule?: string,
        onSelectionRuleError?: (type: string, selectionRule: string) => void,
        onSuccess?: (data: common.ISearchBoxResponseData) => void,
        onError?: (errors: common.IError[]) => void) {
        if (selectionRule && !this.validateSelectionRule(selectionRule, searchBoxArguments.toolsBarActionArguments.selectedItems)) {
            if (onSelectionRuleError) onSelectionRuleError(searchBoxArguments.toolsBarActionArguments.type, selectionRule);
            return;
        }
        if (confirmationsFormData)
            confirmationsFormData.forEach((x, k) => utilities.appendValue(k, x, searchBoxArguments));
        SearchBox.ensureCustomDataPropertyIsValid(searchBoxArguments);
        const r = this.post(searchBoxWebServiceUrl, searchBoxArguments, onSuccess, onError);
        return r;
    }

    private post(url: string, postArgument: any, onSuccess: (data: any) => void, onError?: (errors: common.IError[]) => void) {
        this._lastPostedData = {
            url: url,
            arguments: postArgument
        };
        const request = this._ajaxService.post(url, postArgument, true, (data: any) => {
            this.hideLoader();
            if (this._pageService.validateResponseDataGlobal(data))
                onSuccess(data);
        }, (errors, config) => {
            this.hideLoader();
            onError(errors);
        }, () => {
            this.showLoader();
        }, () => {
            //...
        });

        return request;
    }

    private validateSelectionRule(selectionRule: string, selectedItemIds: common.ISelectedItem[]) {
        selectedItemIds = selectedItemIds || [] as common.ISelectedItem[];

        const totalSelectedItems = selectedItemIds.length;

        if (selectionRule === common.ToolsBarSelectionRules.nothingSelect)
            return totalSelectedItems === 0;

        if (selectionRule === common.ToolsBarSelectionRules.singleSelect)
            return totalSelectedItems === 1;

        if (selectionRule === common.ToolsBarSelectionRules.multiSelect)
            return totalSelectedItems >= 1;

        if (selectionRule === common.ToolsBarSelectionRules.nothingOrSingleSelect)
            return totalSelectedItems <= 1;

        if (selectionRule === common.ToolsBarSelectionRules.nothingOrMultiSelect)
            return true;

        if (selectionRule === common.ToolsBarSelectionRules.bannerAction)
            return true;

        return false;
    }

    private showLoader(applyMaxDuration?: boolean) {
        if (this._loader && (this._searchBoxResultsVue.items || []).length)
            this._loader.show(applyMaxDuration);
    }

    private hideLoader() {
        if (this._loader)
            this._loader.hide();
    }
    clearTerms() {
        this._searchBoxHeaderVue.clearTermsBox();
    }
    setTerms(value: string) {
        this._searchBoxHeaderVue.setTerms(value);
        this._searchBoxHeaderVue.updateSearchParametersFromTerms(value, this._searchParameters);
    }

    setFilter(filter: common.ISearchBoxFilter) {
        return this.setFilters(filter ? [filter] : null);
    }

    setFilters(filters: common.ISearchBoxFilter[]) {
        if (this._searchBoxHeaderVue.setFilters(filters)) {
            this._searchBoxHeaderVue.updateSearchParametersFromFilters(this._searchParameters);
            this.refresh();
        }
    }

    /** Transfere des props de A vers B  */
    private autoMapByKey(a: common.ISearchBoxResult, b: common.ISearchBoxResult, propertyKey: string) {
        if (!a || !b)
            throw "Les objets 'a' et 'b' ne doivent pas être NULL.";

        if (propertyKey === "uid") {
            return;
        }
        else if (propertyKey === "model") {
            if (!b.model)
                b.model = {};
            this.autoMap(a.model || {}, b.model);
            return;
        }

        if (b[propertyKey] !== a[propertyKey])
            b[propertyKey] = a[propertyKey];
    }

    /** Transfere des props de A vers B */
    private autoMap(a: common.ISearchBoxResult, b: common.ISearchBoxResult) {
        if (!a || !b)
            throw "Les objets 'a' et 'b' ne doivent pas être NULL.";

        const keys = [] as string[];
        for (var k in a)
            if (a.hasOwnProperty(k)) {
                this.autoMapByKey(a, b, k);
                keys.push(k);
            }
        for (var k in b)
            if (b.hasOwnProperty(k)) {
                var mustSetDefault = true;
                for (let i = 0; i < keys.length; i++)
                    if (keys[i] === k) {
                        mustSetDefault = false;
                        break;
                    }
                if (mustSetDefault)
                    //a ne contient pas la prop., alors setter la valeur par default
                    this.setDefaultValues(b, k);
            }
    }

    // ITEMS COUNTER =============================================================================================

    // private getItemsCounterOrNull() {
    //    if (!this._searchBoxContext.itemsCounterConfig)
    //        return null;
    //    if (!this._$itemsCounter) {
    //        this._$itemsCounter = this._searchBoxContext.itemsCounterConfig.counterTarget
    //            ? $(this._searchBoxContext.itemsCounterConfig.counterTarget)
    //            : this._$headerActionsRoot.find("[sb-items-counter]");
    //        if (!this._$itemsCounter)
    //            throw "Aucun compteur présent dans la bar d'action";
    //        this._$itemsCounter.show();
    //    }
    //    return this._$itemsCounter || null;
    // }

    // private updateItemsCounter(totalLoadedItems?: number) {
    //     const $e = this.getItemsCounterOrNull();
    //     if (!$e) return;
    //     const format = this._searchBoxContext.itemsCounterConfig.textFormat || "{number} / {total}";
    //     const number = totalLoadedItems || totalLoadedItems === 0
    //         ? totalLoadedItems
    //         : this.getVisibleItemsCount();
    //     const total = this.getTotalResults();
    //     const text = format
    //         .replace("{number}", number.toString())
    //         .replace("{total}", total.toString());
    //     const $t = $e.find("[sb-items-counter-text]");
    //     if ($t.length)
    //         $t.html(text);
    //     else
    //         $e.html(text);
    // }

    // private requireThatAllItemsAreLoaded(actionType: common.ToolsBarActionTypes) {
    //     //if(actionType === common.ToolsBarActionType.SelectAll) return true;
    //     return false;
    // }

    // private allItemsAreLoaded() {
    //     return this.getTotalResults() <= this.estimateLoadedItems();
    // }

    // private estimateLoadedItems() {
    //     const r = (this._searchParameters.pageSize || 1) * (this._searchParameters.pageNumber || 1);
    //     return r;
    // }

    // private reinitSelectionFields(selectPreviousSelectedItems?: boolean) {
    //     selectPreviousSelectedItems = selectPreviousSelectedItems === true;
    //      var isAlreadySelected = (id: string) => {
    //     if (!id) throw "L'item de résultat doit avoir un ID.";
    //     for (var i = 0; i < this._selectedItems.length; i++) {
    //         var x = this._selectedItems[i];
    //         if (x.id.toLowerCase() === id.toLowerCase())
    //             return true;
    //     }
    //     return false;
    // };

    //utilities.initializeAllCheckboxes({
    //    modTarget: '#' + this._searchBoxContext.id + ' .mod-checkbox',
    //    forceReinitAll: true,
    //    onChangeAction: (instance: any) => {
    //        this.onSelectItem(instance);
    //    },
    //    onCheckAction: (instance: any) => {
    //        var $item = instance.$mod().closest('.mod-search-box-result');
    //        var isChecked = instance.isChecked();
    //        const selectedCssClass = 'selected';
    //        if (isChecked)
    //            $item.addClass(selectedCssClass);
    //        else
    //            $item.removeClass(selectedCssClass);
    //    },
    //    onPreInit: instance => {
    //        if (!instance.$mod().attr('chx-group')) return;

    //        var availableModes = instance.getAvailableBehaviorModes();
    //        var behaviorConfig = instance.getBehaviorConfig();

    //        behaviorConfig.mode = availableModes.nothingOrOne;
    //        behaviorConfig.useGroupAttribute = true;
    //        behaviorConfig.$groupsRoot = this._$resultsRoot;

    //        instance.setBehaviorConfig(behaviorConfig);
    //    },
    //    onInitCompleted: instance => {
    //        if (selectPreviousSelectedItems) {
    //            var $e = this.getResultItemFromCheckbox(instance.$mod());
    //            var id = this.getResultItemId($e);

    //            if (isAlreadySelected(id))
    //                instance.check(true, false, true);
    //        }
    //    }
    //} as common.IInitializeAllCheckboxesConfig);
    // }

    // HELPERS =========================================================================
    static transfertCustomData(from: common.IPostCustomData, to: common.IPostCustomData) {
        utilities.ensureCustomDataIsValid(from);
        utilities.ensureCustomDataIsValid(to);

        for (let k1 in from)
            if (from.hasOwnProperty(k1)) {
                to[k1] = to[k1] || {};
                for (let k2 in from[k1])
                    if (from[k1].hasOwnProperty(k2))
                        if (from[k1][k2] !== to[k1][k2])
                            to[k1][k2] = from[k1][k2];
            }
    }
    static ensureCustomDataPropertyIsValid(obj: any) {
        obj.customData = obj.customData || {};
        return utilities.ensureCustomDataIsValid(obj.customData);
    }
}

export = SearchBox;
